import io from 'socket.io-client';
import { createContext } from 'react';

export const socket = io(process.env.NEXT_PUBLIC_CHAT_SERVER_URL, {autoConnect: false, reconnection: 1});
export const SocketContext = createContext();
